import Vue from 'vue';
import { stringify } from 'qs';

export default {
  state: {
    session_id    : null,
    role          : null,
    user_id       : null,
    company       : null,
    affiliate_id  : '0',
    username      : null,
    email         : null,
    first_name    : null,
    last_name     : null,
    error         : null,
    manager       : null,
    preferences   : {
      performanceTabs: ['1'],
      rotatorTabs    : ['2','3','4']
    }
  },
  mutations: {
    user(state, account) {
      state.session_id = account.session_id || null;
      state.role       = account.role || null;
      state.user_id    = account.user_id || null;
      state.username   = account.username || null;
      state.email      = account.email || null;
      state.first_name = account.first_name || null;
      state.last_name  = account.last_name || null;
    },
    affiliate(state, { id, company }) {
      state.affiliate_id = id || '0';
      state.company      = company || null
    },
    manager(state, manager) {
      state.manager = (manager && manager.first_name)? manager: null;
    },
    loginError(state, error) {
      state.error = error || '';
    },
    setPreference(state, { name, value }) {
      state.preferences[name] = value
    }
  },
  getters: {
    isEmployee(state, getters) {
      return ['admin', 'superadmin'].includes(state.role);
    },
    isAffiliate(state, getters) {
      return !getters.isEmployee;
    },
    isImpersonated(state, getters) {
      return getters.isEmployee && state.affiliate_id != '0';
    },
    baseEndpoint(state, getters) {
      return process.env.API_LOCATION + 'v2/';
    },
    affiliateBaseEndpoint(state, getters) {
      return getters.baseEndpoint + 'affiliate/' + state.affiliate_id;
    },
    name(state) {
      return state.first_name + " " + state.last_name
    }
  },
  actions: {
    login({ dispatch, commit }, params) {
      var self = this;

      commit('loginError', null);
      Vue.$http.post('/v2/auth', stringify({ username: params.username || '', password: params.password || '' }), {requestId: 'store-user-login', context: Vue._uid})
            .then(function(response) {
              response = response.data;

              if (response && response.data && response.data.user && response.data.user.session_id) {
                commit('user', { ...response.data.user, username: params.username });

                if (response.data.user.role == 'user')
                  commit('affiliate', { id: response.data.user.hitpath_account_id, company: response.data.user.company });

                if (response.data.user.manager)
                  commit('manager', response.data.user.manager);

                return Vue.router.push({
                  name: 'performance',
                });
              }
            }).catch((error) => {
              let message = 'An unknown error occurred while logging in'

              if (Vue.$http.isApiError(error) && error.response.data._meta.errors)
                message = error.response.data._meta.errors.join(', ')

              commit('loginError', message);
              dispatch('logout', params.callback || null);
            });
    },
    logout({ state, dispatch, commit }, callback) {
      commit('user', { username: state.username });
      commit('manager', null);
      dispatch('affiliate', { id: null, company: null });

      Vue.router.push({
        name: 'login',
      });

      if (typeof callback === "function")
        callback(state.error);
    },
    affiliate({ rootState, state, commit, getters }, affiliate) {
      if (affiliate.id != state.affiliate_id)
        commit('clearUserCache')

      commit('affiliate', affiliate)
      if (affiliate && getters.isEmployee) {
        Vue.router.push({ ...rootState.route })
        Vue.$http.get('/v2/me?affiliate_id=' + (affiliate.id || 0), {requestId: 'store-user-get-affiliate-data', context: Vue._id})
          .then(function(response) {
            response = response.data;

            commit('manager', affiliate.id != '0' && response && response.data && response.data.user && response.data.user.manager)

            if (response && response.data && response.data.company)
              commit('affiliate', { ...affiliate, company: response.data.company })
          })
          .catch((error) => {
            if (Vue.$http.isApiError(error))
              commit('manager', null);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js